import React from 'react'
import Transactions from '../features/transactions/Transactions'

const TransactionsPage = () => {
  return (
    <Transactions/>
  )
}

export default TransactionsPage